const SARP_COMMUNITY_PETITION_USER_ID = '1364342708';

export function isACommunityPetition(petitionUserId: string): boolean {
	return petitionUserId === SARP_COMMUNITY_PETITION_USER_ID;
}
